var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Core
import React from 'react';
import { debounce } from '../../utils/debounce';
import { getPlacePredictions } from '../../services/geocode';
import { Grid, makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography/Typography';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Autocomplete from '@material-ui/lab/Autocomplete';
var useStyles = makeStyles(function (theme) { return ({
    icon: {
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(2),
    },
}); });
var simpleFeature = { type: 'SimpleFeature', properties: { label: '' } };
/**
 * AutocompleteDigiMaps component
 */
var AutocompleteDigiMaps = function (_a) {
    var InputRender = _a.InputRender, InputProps = _a.InputProps, place = _a.place, onSelect = _a.onSelect;
    var classes = useStyles();
    var defaultValue = place ? place.properties.label : '';
    /** State */
    var _b = React.useState(place ? place.properties.label : defaultValue), inputValue = _b[0], setInputValue = _b[1];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var _c = React.useState((place !== null && place !== void 0 ? place : simpleFeature)), selectedPlace = _c[0], setSelectedPlace = _c[1];
    var _d = React.useState({ options: [], predictionsOpen: false }), prediction = _d[0], setPrediction = _d[1];
    var predictionsOpen = prediction.predictionsOpen, options = prediction.options;
    var handleChange = function (event) {
        setInputValue(event.target.value);
    };
    var handleSelect = function (option) {
        setSelectedPlace(option);
    };
    var getPredictions = React.useMemo(function () {
        return debounce(function (inputValue) { return __awaiter(void 0, void 0, void 0, function () {
            var placePredictionList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getPlacePredictions(inputValue, true)];
                    case 1:
                        placePredictionList = _a.sent();
                        if (placePredictionList.success && placePredictionList.data.features.length) {
                            setPrediction(__assign(__assign({}, prediction), { options: placePredictionList.data.features }));
                        }
                        else if (options.length) {
                            setPrediction(__assign(__assign({}, prediction), { options: [] }));
                        }
                        return [2 /*return*/];
                }
            });
        }); }, 500);
    }, []);
    var handleClose = function () {
        // todo fix check
        if (options.length && !selectedPlace.properties.label) {
            var defaultOptions = options[0];
            setInputValue(defaultOptions.properties.label);
            setSelectedPlace(defaultOptions);
        }
        setPrediction({ options: [], predictionsOpen: false });
    };
    var handleOpen = function () {
        setPrediction(__assign(__assign({}, prediction), { predictionsOpen: true }));
    };
    var getOptionSelected = function (option, value) {
        return option.properties.label.toLowerCase() === (value ? value.properties.label.toLowerCase() : value);
    };
    React.useEffect(function () {
        if (!predictionsOpen && !selectedPlace) {
            setInputValue('');
        }
        else if (predictionsOpen) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            setSelectedPlace(simpleFeature);
        }
    }, [predictionsOpen]);
    React.useEffect(function () {
        if (inputValue === '') {
            setPrediction(__assign(__assign({}, prediction), { options: [] }));
            return undefined;
        }
        getPredictions(inputValue);
    }, [inputValue]);
    React.useEffect(function () {
        if (selectedPlace.type === 'Feature') {
            onSelect(selectedPlace);
            setInputValue(selectedPlace.properties.label);
        }
        else {
            onSelect(undefined);
            setInputValue('');
        }
    }, [selectedPlace]);
    return (React.createElement(Autocomplete, { id: "google-map-demo", style: { width: '100%' }, getOptionLabel: function (option) { return (typeof option === 'string' ? option : option.properties.label); }, filterOptions: function (x) { return x; }, options: options, autoComplete: true, value: selectedPlace, includeInputInList: true, freeSolo: true, onOpen: handleOpen, inputValue: inputValue, disableClearable: true, getOptionSelected: getOptionSelected, onClose: handleClose, renderInput: function (params) { return React.createElement(InputRender, __assign({ onChange: handleChange }, params, InputProps)); }, renderOption: function (option) {
            return (React.createElement(Grid, { container: true, alignItems: "center", onClick: function () { return handleSelect(option); } },
                React.createElement(Grid, { item: true },
                    React.createElement(LocationOnIcon, { className: classes.icon })),
                React.createElement(Grid, { item: true, xs: true },
                    option.properties.label,
                    React.createElement(Typography, { variant: "body2", color: "textSecondary" }, option.properties.context))));
        } }));
};
export default AutocompleteDigiMaps;
//# sourceMappingURL=AutocompleteDigiMaps.js.map